import { GameType } from '@daymade/common-lib/dbEnums';
import ArcadeProgressBar from 'components/token-town/ArcadeProgressBar';
import GenericTokenRedemptionCard from 'components/token-town/GenericTokenRedemptionCard';
import { TTokenRedemptionOptionsItem } from 'pages/token-town';
import { ASSET_PREFIX } from 'utils/constants';

interface IMinigameCard {
  redemptionOption: TTokenRedemptionOptionsItem;
  tokenBalance: number;
  onClick: () => void;
  locked?: boolean;
  className?: string;
}

const MinigameCard = ({
  redemptionOption,
  tokenBalance,
  onClick,
  locked,
  className,
}: IMinigameCard) => {
  return (
    <GenericTokenRedemptionCard
      className={className}
      imagePath={
        redemptionOption.heroImage ||
        redemptionOption.drawDetails?.prizeImageLocation ||
        undefined
      }
      redemptionCost={redemptionOption.price}
      tokenBalance={tokenBalance}
      onClick={onClick}
      showGuaranteedWinnerBanner={
        redemptionOption.drawDetails?.gameType === GameType.RAFFLE
      }
      nextDrawDate={
        redemptionOption.drawDetails?.nextDrawDate &&
        new Date(redemptionOption.drawDetails?.nextDrawDate) // workaround nextjs serialization issue
      }
      redemptionOptionLocked={locked}
    >
      <h4 className="minigameCardTitle">
        {redemptionOption.title || redemptionOption.drawDetails?.prizeTitle}
      </h4>
      <p className="minigameCardDescription">
        {redemptionOption.description ||
          redemptionOption.drawDetails?.prizeSubheading}
      </p>

      {redemptionOption.drawDetails?.entryCap && (
        <>
          <ArcadeProgressBar
            totalSteps={redemptionOption.drawDetails.entryCap}
            currentStep={redemptionOption.drawDetails.numEntries || 0}
          />

          <div className="gameSpecificInfo flexRow flexSpaceBetween">
            {!redemptionOption.drawDetails.schedule && (
              <div className="flexCentered flexRow">
                <img
                  src={`${ASSET_PREFIX}/images/token-town/arcade-bomb.svg`}
                  style={{ marginTop: '-5px' }}
                  alt=""
                />
                <h5 className="green">Instant draw</h5>
              </div>
            )}

            <div className="flexCentered flexRow">
              <img src={`${ASSET_PREFIX}/images/token-town/ticket.png`} />
              <h5 className="green">
                {redemptionOption.drawDetails.numEntries || 0}/
                {redemptionOption.drawDetails.entryCap}
              </h5>
            </div>
          </div>
        </>
      )}

      {redemptionOption.drawDetails?.gameType === GameType.LOTTERY &&
        redemptionOption.drawDetails.numberSetup?.main.length === 1 &&
        redemptionOption.drawDetails.numberSetup.bonus.length === 0 && (
          <div className="gameSpecificInfo flexRow flexSpaceBetween">
            <div className="flexCentered flexRow">
              <img src={`${ASSET_PREFIX}/images/token-town/ticket.png`} />
              <h5 className="green">
                Fixed chances: &nbsp;
                <span style={{ whiteSpace: 'nowrap' }}>
                  1 in{' '}
                  {redemptionOption.drawDetails.numberSetup.main[0]?.toLocaleString(
                    'en-GB',
                  )}
                </span>
              </h5>
            </div>
          </div>
        )}

      <style jsx>
        {`
          .gameSpecificInfo {
            width: 100%;
            align-items: center;
            margin-top: 1em;
            display: flex;
            gap: 10px;
          }

          .minigameCardTitle {
            font-size: 13px;
            font-weight: 800;
            line-height: 15px;
            letter-spacing: 0;
            text-transform: none;
          }

          .minigameCardDescription {
            font-size: 10px;
            font-weight: 600;
            line-height: 12px;
            letter-spacing: 0;
          }

          @media (max-width: 900px) {
            .gameSpecificInfo {
              flex-direction: column-reverse;
              align-items: flex-start;
            }

            .gameSpecificInfo > div {
              margin-bottom: 2px;
            }
          }

          .gameSpecificInfo img {
            width: 15px;
            margin-right: 0.5em;
          }

          .gameSpecificInfo h5 {
            font-size: 0.9em !important;
            margin: 0;
            text-transform: uppercase;
            line-height: 1.5;
            text-align: left;
          }

          .minigameCardDescription {
            flex-grow: 1;
          }

          .green {
            color: #50e3c2;
          }

          @media (min-width: 700px) {
            .minigameCardTitle {
              font-size: 22px;
              line-height: 26px;
            }

            .minigameCardDescription {
              font-size: 16px;
              line-height: 26px;
            }
          }

          @media (min-width: 385px) {
            .gameSpecificInfo img {
              width: 13px;
              margin-right: 0.4em;
            }

            .gameSpecificInfo h5 {
              font-size: 1em !important;
            }
          }

          @media (min-width: 450px) {
            .gameSpecificInfo img {
              width: 16px;
              margin-right: 0.75em;
            }

            .gameSpecificInfo h5 {
              font-size: 1.1em !important;
            }
          }
        `}
      </style>
    </GenericTokenRedemptionCard>
  );
};

export default MinigameCard;
